<template>
    <v-row no-gutters class="search-progress pb-3">
        <SearchProgressNote />
        <v-col :cols="searchActive && !hideStopBtn ? ($breakpoint.smAndDown ? 10 : 11) : 12">
            <v-progress-linear
                :model-value="progress"
                color="primary"
                :height="!$breakpoint.smAndDown ? 25 : 50"
                :indeterminate="searchActive"
            >
                <template v-slot="{}">
                    <span class="progress-label">
                        {{ progressLabel }}
                    </span>
                </template>
            </v-progress-linear>
        </v-col>
        <v-col v-if="searchActive && !hideStopBtn" cols="2" sm="1" class="ps-3">
            <v-btn
                variant="flat"
                :size="$breakpoint.smAndDown ? 'x-small' : 'small'"
                block
                class="bg-primary"
                data-cy="stop-search-button"
                :height="!$breakpoint.smAndDown ? 25 : 50"
                @click="stop"
            >
                {{ $t('stop') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchProgressNote from '~src/components/search/SearchProgressNote.vue'

    @Component({
        components: {SearchProgressNote},
    })
    export class SearchProgress extends Vue {
        @Prop({required: true, default: 0}) filteredOffersCount
        @Prop({required: true, default: 0}) totalOffersCount
        @Prop({required: true, default: true}) searchActive
        @Prop({default: false, type: Boolean}) hideStopBtn

        progress = 0

        @Emit()
        stop() {}

        @Watch('searchActive')
        changeLoading(searchActive) {
            if (!searchActive) {
                this.progress = 100
            }
        }

        mounted() {
            if (!this.searchActive) {
                this.progress = 100
            }
        }

        get progressLabel() {
            return this.totalOffersCount === 0 && this.searchActive
                ? this.$t('searching')
                : !this.searchActive && this.filteredOffersCount !== this.totalOffersCount
                  ? `${this.filteredOffersCount} ${this.$t('out_of')} ${this.totalOffersCount} ${this.$t(
                        'offer',
                        this.totalOffersCount
                    )} ${this.$t('match_filters')}`
                  : this.searchActive
                    ? `${this.totalOffersCount} ${this.$t('offer', this.totalOffersCount)}`
                    : this.$t('offer_found', {
                          offer: `${this.totalOffersCount} ${this.$t('offer', this.totalOffersCount)}`,
                      })
        }

        get isSearchActive() {
            return this.searchActive
        }

        get offersCount() {
            return this.totalOffersCount
        }
    }

    export default SearchProgress
</script>

<style scoped>
    .progress-label {
        color: white;
        text-align: center;
    }
</style>
